import { render, staticRenderFns } from "./taskCard.vue?vue&type=template&id=71d44c48&"
import script from "./taskCard.vue?vue&type=script&lang=js&"
export * from "./taskCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports